import { Typography, Stack, styled } from '@mui/material';

export const StatisticsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(4),
  [theme.breakpoints.between('md', 'desktop')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
}));

export const StatContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  flexDirection: 'row',
  alignItems: 'flex-end',
  overflow: 'hidden',
}));

export const StatName = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[300],
  fontSize: 12,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
